'use strict';
module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/index.js
// module id = 174
// module chunks = 96961042003272 139266963665775